import React, {useCallback, useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './PolicyLineLevelCoveragesComponent.metadata.json5';
import messages from "gw-capability-fnol-ca-react/FNOLCA.messages";

const getCellCoverageName = (rowData) => {
    const value = rowData.name? rowData.name : '-'
    return (
        <span>
            {value}
        </span>
    );
};

const getCellCoverageLimit = (rowData) => {
    const value = rowData.limit? rowData.limit : '-'
    return (
        <span>
            {value}
        </span>
    );
};

const getCellCoverageDeductible = (rowData) => {
    const value = rowData.deductible? rowData.deductible : '-'
    return (
        <span>
            {value}
        </span>
    );
};


function PolicyLineLevelCoveragesComponent(props) {
    const { value: currentPeriodDetails } = props;

    if (_.isEmpty(currentPeriodDetails) || currentPeriodDetails === undefined) {
        return null;
    }

   /*  if (_.isEmpty(currentPeriodDetails) || currentPeriodDetails === undefined) {
        return null;
    } */

    const { coverables } = currentPeriodDetails;

    const policyLineCoverages = useMemo(() => {
        const selectedCoverable = coverables.find((coverable) => {
            return (coverable.name === 'Commercial Property' || coverable.name === 'Residential Line');
        });
        if (selectedCoverable) {
            return selectedCoverable.coverages.filter((cov) => {
                return (cov.name !== 'Minimum Premium Coverage' && cov.name !== 'Statutory and Additional Conditions, Terrorism Exclusion');
            });
        }
    }, [currentPeriodDetails]);


    const overrides = {
        PolicyLineLevelCoveragesTable: {
            data: policyLineCoverages
        },
        policyLineLevelCoverageColumn: { onCell: getCellCoverageName },
        policyLineLevelLimitColumn: { onCell: getCellCoverageLimit },
        policyLineLevelDeductibleColumn: { onCell: getCellCoverageDeductible }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={policyLineCoverages}
            overrideProps={overrides}
        />
    );
}


PolicyLineLevelCoveragesComponent.propTypes = {
    value: PropTypes.shape({})
};

PolicyLineLevelCoveragesComponent.defaultProps = {
    value: []
};

export default PolicyLineLevelCoveragesComponent;
